import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/conversationParticipant/importer/conversationParticipantImporterActions'

export default importerReducers(actions)
